export const ANALYTICS_EVENT_RULES = {
  CUSTOM_LINK: 'customLink',
  PAGE_LOAD: 'pageLoad',
};
